export default __webpack_public_path__ + "static/CopernicusWeb-BookItalic-477c53d0c2e773717a2c0922bba138cc.woff2";